import styled from 'styled-components';

export function Switch({ checked, onChange, onClick, ...props }) {
  const handleChange = (event) => {
    if (onChange) onChange(event.target.checked);
  };

  const handleClick = (event) => {
    if (onClick) onClick(event.target.checked);
  };

  return (
    <SwitchLabel>
      <Input type="checkbox" checked={checked || false} onClick={handleClick} onChange={handleChange} {...props} />
      <Slider className="slider" />
    </SwitchLabel>
  );
}

const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
`;

const Input = styled.input`
  display: none;

  &:checked + .slider {
    background-color: ${({ theme }) => theme.colors.primary};
  }

  &:checked + .slider:before {
    transform: translateX(25px);
  }
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.gray300};
  transition: 0.4s;
  border-radius: 16px;

  &::before {
    position: absolute;
    content: '';
    height: 24px;
    width: 24px;
    left: 0;
    bottom: 0;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
    box-shadow: ${({ theme }) => theme.shadows.elevation01};
  }
`;
